import {Component , OnInit} from '@angular/core';
import {ProductsService} from '../../../services';

import {ProductAddQuickService} from './service/product-add-quick.service';
import {exhaustMap, } from 'rxjs/operators';
import {ProductBcDto} from './DTO/productBc.dto';
import {of} from "rxjs";

@Component({
  selector: 'app-product-add-quick',
  templateUrl: './product-add-quick.component.html',
  styleUrls: ['./product-add-quick.component.scss']
})
export class ProductAddQuickComponent implements OnInit {
  ids;
  mapOfCheckedId;
   productBC$;
   page = 1;
   pageSize = 10;
   total;
  loading = true;
  inputSearch = '';
  arrBarCode = [];
  lstProductAdd: ProductBcDto[];
  isCheckAll = false;
  subscriptionId;
  subscriptions;
  isRequired;
  isDisable = false;
  constructor(private productAddBC: ProductAddQuickService , private productService: ProductsService) {
  }
  ngOnInit() {
     this.getAllProductBC();
     this.loadDataSubscription();
  }
  getAllProductBC(query?, search?) {
    this.loading = true;
    if (!query) {
       query = {
         page: this.page,
         page_size: this.pageSize,
       };
     }
    if (search) { query.search = search; }
    this.isCheckAll = false;
    this.productBC$ = this.productAddBC.getProductBC(query).pipe(exhaustMap(z => {
       this.loading = false;
       this.total = z.data.total;
       this.page = z.data.page;
       this.pageSize = z.data.pageSize;
       this.lstProductAdd = z.data.listResponse;
       return of(z.data.listResponse) ;
  }));
  }

  addBarCode(barcode) {
    const index = this.arrBarCode.indexOf(barcode);
    if (index !== -1) {
      this.arrBarCode.splice(index , 1);
      return;
    }
    this.arrBarCode.push(barcode);
  }

  checkAll(value: boolean): void {
    if (value) {
      this.isCheckAll = true;
      this.arrBarCode = this.lstProductAdd.map(z => z.barcode);
      return;
    }
    this.isCheckAll = false;
    this.arrBarCode = [];
  }
  currentPageDataChange($event: any[]): void {

  }
  loadDataIndex(event) {
      const query = {
        page: event,
        page_size: this.pageSize
      };
      this.isCheckAll = false;
      this.getAllProductBC(query);
  }
  loadDataPageSize(event) {
    const query = {
      page: this.page,
      page_size: event
    };
    this.isCheckAll = false;
    this.getAllProductBC(query);
  }
  search(event) {
    this.getAllProductBC(null, event);
  }

  loadDataSubscription() {
    this.productService.getAllSubscription().pipe().subscribe(
      (res) => {
        const data = [];
        res.data.map(item => {
          if (item.status === 0) {
            item.status = 'Hủy kích hoạt';
          }
          if (item.status === 1) {
            item.status = 'Kích hoạt';
          }
          if (item.status === 2) {
            item.status = 'Chờ kích hoạt';
          }
          if (item.status === 3) {
            item.status = 'Hết hạn';
          }
          if (item.status === 4) {
            item.status = 'Hết hạn';
          }
          item.expirationAt = item.expirationAt.length !== null ?  item.expirationAt.substr(0, 10) : item.expirationAt;
          item.trialExpirationAt = item.trialExpirationAt !== null ?  item.trialExpirationAt.substr(0, 10) : item.trialExpirationAt;
          data.push(item);
        });
        this.subscriptions = data;

        if (this.subscriptions && this.subscriptions.length === 1) {
          this.sub(data[0]);
        }
      }
    );
  }

  selectPackage(data) {
    console.log(data);
  }
  sub(data: any) {
    console.log(data)
    this.subscriptionId = data.id;
    this.isRequired = !data.id;
    // this.isDisable = !data.remainProduct;
    if (!data.remainProduct) {
      this.isDisable = true;
      this.isCheckAll = false;
      this.arrBarCode = [];
      return;
    }
    this.isDisable = false;

  }
}
